import config from 'config';
import { DataResolver } from './types/DataResolver';
import { processURLAddress } from '@vue-storefront/core/helpers';
import { TaskQueue } from '@vue-storefront/core/lib/sync'
import getApiEndpointUrl from '@vue-storefront/core/helpers/getApiEndpointUrl';

const isSubscribed = (email: string): Promise<boolean> =>
  TaskQueue.execute({
    url: processURLAddress(getApiEndpointUrl(config.newsletter, 'endpoint')) + '?email=' + encodeURIComponent(email),
    payload: {
      method: 'GET',
      headers: { 'Content-Type': 'application/json' },
      mode: 'cors'
    },
    silent: true
  }).then(({ result }) => result === 'subscribed')

const subscribe = (email: string): Promise<boolean> =>
  TaskQueue.execute({
    url: processURLAddress(getApiEndpointUrl(config.newsletter, 'endpoint')),
    payload: {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      mode: 'cors',
      body: JSON.stringify({ email })
    }
  }).then(({ code }) => code === 200)

const unsubscribe = (email: string): Promise<boolean> =>
  TaskQueue.execute({
    url: processURLAddress(getApiEndpointUrl(config.newsletter, 'endpoint')),
    payload: {
      method: 'DELETE',
      headers: { 'Content-Type': 'application/json' },
      mode: 'cors',
      body: JSON.stringify({ email })
    }
  }).then(({ code }) => code === 200)

// Event Reminder API integration
const subscribeToEventReminder = (email: string, entityType: 'artist' | 'event', entityId: number, newsletterOptIn?: boolean): Promise<boolean> =>
  TaskQueue.execute({
    url: processURLAddress(getApiEndpointUrl(config.eventReminder, 'subscribe')),
    payload: {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      mode: 'cors',
      body: JSON.stringify({ email, entityType, entityId, newsletterOptIn })
    }
  }).then(({ code }) => code === 200)

const getEventReminderSubscriptions = (email: string): Promise<Array<{ entityType: string; entityId: number }>> =>
  TaskQueue.execute({
    url: processURLAddress(getApiEndpointUrl(config.eventReminder, 'subscriptions')) + '/' + encodeURIComponent(email),
    payload: {
      method: 'GET',
      headers: { 'Content-Type': 'application/json' },
      mode: 'cors'
    },
    silent: true
  }).then(({ code, result }) => {
    if (code === 200 && result && result.data && result.data.subscriptions) {
      return result.data.subscriptions
    }
    return []
  })

const isSubscribedToEventReminder = (email: string, entityType: 'artist' | 'event', entityId: number): Promise<boolean> =>
  getEventReminderSubscriptions(email).then((subscriptions) =>
    subscriptions.some(sub => sub.entityType === entityType && sub.entityId === entityId)
  )

export const NewsletterService = {
  isSubscribed,
  subscribe,
  unsubscribe,
  subscribeToEventReminder,
  getEventReminderSubscriptions,
  isSubscribedToEventReminder
}
